<template>
    <div ref="lavContainer" class="lav"></div>
</template>

<script>
    import lottie from "lottie-web";
    import * as animationData from "../../assets/data.json";
    
    export default {
        mounted () {
            this.animation = lottie.loadAnimation({
                container: this.$refs.lavContainer,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: animationData.default
            });
            this.$emit("animCreated", this.animation);
        }
    }
</script>

<style lang="scss" scoped>
.lav {
    width: 100px;
    height: 100px;
}
</style>

